import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";
import { adminValidation } from "../library/service";
import { elsevierStyleSheetJSfileImport, indianCurrencyFormat } from "../library/utils";
import CartDetailsAdmin from "./CartDetailsAdmin";
import Popup from '../components/Popup';

const OrderHistoryAdmin = () => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [orderID, setOrderID] = useState("");
  const [totalProducts, setTotalProducts] = useState([]);
  const [dropDownYears, setDropDownYears] = useState([]);
  const [sendableItems, setSendableItems] = useState([]);
  const [fallbackProducts, setFallbackProducts] = useState([]);
  const [unfilteredProducts, setUnfilteredProducts] = useState([]);
  const [showOrderDetails, setShowOrderDetails] = useState(true);
  const [showCartDetails, setShowCartDetails] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');
  const [localReferenceNumbers, setLocalReferenceNumbers] = useState({});
  const [localIncidentNumbers, setLocalIncidentNumbers] = useState({});
  const [checkedOrders, setCheckedOrders] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    adminAuth();
    authUser();
    fetchYears();
    getOrderHistory();
    elsevierStyleSheetJSfileImport();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (props) => {
    setSearchKeyword(props.target.value);
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
    }
  };

  const adminAuth = async () => {
    const authorized = await adminValidation();
    if (!authorized) {
      navigate('/');
    } else if (authorized && authorized.data.is_admin) {
      setAdmin(true);
    } else {
      navigate("/unAuthorized");
    }
  };

  const findProducts = () => {
    let keyword = searchKeyword.replace(/\s+/g, "");
    let products = totalProducts;
    if (keyword === "") {
      setFallbackProducts(products);
    } else {
      let searchResult = products.filter((el) => el.orderID === keyword);
      setFallbackProducts(searchResult);
    }
  };

  const handleFiltering = (event) => {
    let time = event.currentTarget.innerText;
    let sortedData = [];


    if (time === "Last week") {
      let today = new Date();
      let lastWeek = new Date();
      lastWeek.setDate(today.getDate() - 7);
      lastWeek.setHours(0, 0, 0, 0);
      sortedData = unfilteredProducts.filter((product) => {
        let productDateTime = new Date(product.date).getTime();
        return productDateTime >= lastWeek.getTime() && productDateTime <= today.getTime();
      });
    } else if (time === "This month") {
      let today = new Date();
      let thisMonth = today.toLocaleString("en-US", { month: "short" }) + String(today.getFullYear());
      sortedData = unfilteredProducts.filter((product) => {
        let productMonth = product.date.split(" ")[2] + product.date.split(" ")[3];
        return thisMonth === productMonth;
      });
    } else if (time.split(" ")[0] === "Year") {
      dropDownYears.forEach((year) => {
        if (String(time.split(" ")[1]) === String(year)) {
          sortedData = unfilteredProducts.filter((product) => {
            return String(year) === product.date.split(" ")[3];
          });
        }
      });
    } else {
      getOrderHistory();
      return; // Exit if no valid filter is selected
    }

    // Check if sortedData is empty and revert to original data if necessary
    if (sortedData.length === 0) {
      setFallbackProducts(totalProducts); // Revert to original data
      handleShowPopup("Order History", "No orders found for the selected filter.");
    } else {
      setFallbackProducts(sortedData);
    }
  };

  const fetchYears = () => {
    var initialYear = 2022;
    var currentYear = new Date().getFullYear();
    var years = [];
    for (let i = initialYear; i <= currentYear; i++) years.push(i);
    setDropDownYears(years);
  };

  const getOrderHistory = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    var config = {
      method: "post",
      url: `${backendBookartUrl}/orderDetails`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        let products = response.data.orders;
        setTotalProducts(products);
        setFallbackProducts(products);
        setUnfilteredProducts(products);
      })
      .catch((errors) => {
        console.log(errors);
      });
  };


  const getReferenceNumber = (orderID) => {
    if (orderID in localReferenceNumbers) return localReferenceNumbers[orderID];
    const order = totalProducts.find((el) => el.orderID === orderID);
    return order?.reference_number ?? "";
  };

  const getIncidentNumber = (orderID) => {
    if (orderID in localIncidentNumbers) return localIncidentNumbers[orderID];
    const order = totalProducts.find((el) => el.orderID === orderID);
    return order?.incident_number ?? "";
  };

  const checkmark = (orderNo) => {
    const orderID = orderNo.target.value;
    const isChecked = orderNo.target.checked;

    setCheckedOrders(prev => ({ ...prev, [orderID]: isChecked }));

    if (isChecked) {
        const newItem = {
            orderID: orderID,
            referenceID: getReferenceNumber(orderID),
            incidentnumber: getIncidentNumber(orderID),
        };

        setSendableItems((prevSendableItems) => {
            const existingIndex = prevSendableItems.findIndex(item => item.orderID === newItem.orderID);
            if (existingIndex > -1) {
                const updatedItems = [...prevSendableItems];
                updatedItems[existingIndex] = newItem;
                return updatedItems;
            } else {
                return [...prevSendableItems, newItem];
            }
        });
    } else {
        setSendableItems(prevSendableItems =>
            prevSendableItems.filter(item => item.orderID !== orderID)
        );
    }
};

const updateReferenceNumber = (orderID, newReferenceNumber) => {
    setLocalReferenceNumbers(prev => ({
        ...prev,
        [orderID]: newReferenceNumber // Update local reference number
    }));
};

const updateIncidentNumber = (orderID, newIncidentNumber) => {
    setLocalIncidentNumbers(prev => ({
        ...prev,
        [orderID]: newIncidentNumber // Update local incident number
    }));
};

  const sendUpdate = (props) => {
    const token = window.sessionStorage.getItem("JWTtoken");
    let status = props.target.innerText;
    console.log("update Data", sendableItems);
    const sendingData = sendableItems.map(item => ({
      ...item,
      referenceID: getReferenceNumber(item.orderID),
      incidentnumber: getIncidentNumber(item.orderID),
    }));

    const data = JSON.stringify({
      status: status,
      orderDetails: sendingData,
    });

    const config = {
      method: "post",
      url: `${backendBookartUrl}/orderDetails/Status`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        setSendableItems([]);
        setCheckedOrders({});
        setLocalReferenceNumbers({});
        setLocalIncidentNumbers({});
        getOrderHistory();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const showCartdetail = (orderid) => {
    setOrderID(orderid);
    setShowOrderDetails(false);
    setShowCartDetails(true);
  };

  const returnToStart = () => {
    setOrderID("");
    setShowCartDetails(false);
    setShowOrderDetails(true);
  };

  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  if (!admin) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <div className="container min-height60">
          {showOrderDetails ? (
            <section className="container min-height60">
              <h2>Order History</h2>

              <div className="search-bar-section">
                <div className="es-input-text search-term">
                  <input
                    id="searchKeyword"
                    type="text"
                    name="searchKeyword"
                    placeholder="&nbsp;"
                    onChange={handleChange}
                    value={searchKeyword}
                  />
                  <label htmlFor="searchKeyword" className="search-label">
                    <h3 className="order-history-search">Search by Order number</h3>
                  </label>
                  <button
                    onClick={findProducts}
                    className="search-button search-button-order-history"
                    type="submit"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 128"
                      height="24"
                      width="16"
                    >
                      <path
                        fill="#007398"
                        d="M19.22 76.91c-5.84-5.84-9.05-13.6-9.05-21.85s3.21-16.01 9.05-21.85c5.84-5.83 13.59-9.05 21.85-9.05 8.25 0 16.01 3.22 21.84 9.05 5.84 5.84 9.05 13.6 9.05 21.85s-3.21 16.01-9.05 21.85c-5.83 5.83-13.59 9.05-21.84 9.05-8.26 0-16.01-3.22-21.85-9.05zm80.33 29.6L73.23 80.19c5.61-7.15 8.68-15.9 8.68-25.13 0-10.91-4.25-21.17-11.96-28.88-7.72-7.71-17.97-11.96-28.88-11.96S19.9 18.47 12.19 26.18C4.47 33.89.22 44.15.22 55.06s4.25 21.17 11.97 28.88C19.9 91.65 30.16 95.9 41.07 95.9c9.23 0 17.98-3.07 25.13-8.68l26.32 26.32 7.03-7.03"
                      />
                    </svg>
                  </button>
                </div>
                <div className="dropdown-sort">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle es-button primary"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Sort By
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <li>
                        <button type="button"
                          onClick={handleFiltering}
                          className="dropdown-item"
                          name="sort-button"
                          value="lastWeek"
                        >
                          Last week
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={handleFiltering}
                          className="dropdown-item"
                          name="sort-button"
                          value="This Month"
                        >
                          This month
                        </button>
                      </li>
                      {dropDownYears.map((el) => (
                        <li key={el}>
                          <button type="button"
                            onClick={handleFiltering}
                            className="dropdown-item"
                            name="sort-button"
                            value={el}
                          >
                            {"Year " + el}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="dropdown-update">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle es-button primary"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Update Status
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="processed"
                        >
                          Processed
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="partially fulfilled"
                        >
                          Partially Fulfilled
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="fulfilled"
                        >
                          Fulfilled
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="credit on hold"
                        >
                          Credit On Hold
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="Backordered"
                        >
                          Backordered
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="Cancelled"
                        >
                          Cancelled
                        </button>
                      </li>
                      <li>
                        <button type="button"
                          onClick={sendUpdate}
                          className="dropdown-item"
                          name="submit-button"
                          value="Not Processed"
                        >
                          Not Processed
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="orderHistoryTable table">
                <table className="table table-borderless ">
                  <thead className="cart-table-header sticky-table-head">
                    <tr>
                      <th scope="col">Order No</th>
                      <th scope="col">Email address</th>
                      <th scope="col">User Name</th>
                      <th scope="col">Order On</th>
                      <th scope="col">Grand Total</th>
                      <th scope="col">Reference Id</th>
                      <th scope="col">Incident Number</th>
                      <th scope="col"> Status </th>
                    </tr>
                  </thead>
                  <tbody>
                    {fallbackProducts.map((el) => (
                      <tr key={el.orderID}>
                        <td className="checkbox-orderDetails-admin">
                          <label className="es-check small">
                            <input
                              form="myForm"
                              className="es-check-input allcheckboxes"
                              name={el.orderID}
                              value={el.orderID}
                              type="checkbox"
                              checked={!!checkedOrders[el.orderID]}
                              onChange={(e) => checkmark(e)}
                            />
                          </label>
                          <div
                            onClick={() => showCartdetail(el.orderID)} // Fix: Use an arrow function
                            className="es-link colored font-16"
                            style={{ cursor: 'pointer' }} // Change cursor to pointer
                          >
                            {el.orderID}
                          </div>
                        </td>
                        <td className="color-light-ash font-16">{el.email}</td>
                        <td className="color-light-ash font-16">{el.customer_name}</td>
                        <td className="color-light-ash font-16">{el.date}</td>
                        <td className="color-light-ash font-16">₹{indianCurrencyFormat(el.grandTotal)}</td>
                        <td className={el.referenceID}>
                          <input
                            value={getReferenceNumber(el.orderID)}
                            className="color-light-ash font-16"
                            onChange={(e) => {
                              const newReferenceNumber = e.target.value;
                              // Update reference number for the respective order ID
                              updateReferenceNumber(el.orderID, newReferenceNumber);
                          }}
                          />
                        </td>
                        <td className="color-light-ash font-16">
                          <input
                            value={getIncidentNumber(el.orderID)}
                            className="color-light-ash font-16"
                            onChange={(e) => {
                              const newIncidentNumber = e.target.value;
                              // Update incident number for the respective order ID
                              updateIncidentNumber(el.orderID, newIncidentNumber);
                          }}
                          />
                        </td>
                        <td className="color-light-ash font-16">{el.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          ) : (
            <div></div>
          )}
          {showCartDetails ? (<>
            <div className="container back-home">
              <div>
                <button className="es-link colored font-16" onClick={returnToStart}>
                  <svg viewBox="0 0 54 128" height="16" width="11">
                    <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
                  </svg>
                  &nbsp;Back to Order History
                </button>
              </div>
            </div>
            <CartDetailsAdmin data={orderID} backToStart={returnToStart} />
          </>
          ) : (
            <div></div>
          )}
          <Popup
            title={popupTitle}
            message={popupMessage}
            show={showPopup}
            handleClose={handleClosePopup}
          />
        </div>
      </React.Fragment>
    );
  }
};

export default OrderHistoryAdmin;